/** Import modules */

import { NavLink }          from "react-router-dom";

/** Import datasets */

import PoliciesDatasets     from "../../Datasets/Policies";

/** Import assets */

import "../../Styles/Policies.css";

/**
 * 
 * @param {title, children} param0 
 * 
 * @returns Policies layout component
 * 
 */

const PoliciesLayout = ( { title, children } ) => {

    /** Return component */

    return ( <div className="content policies">

        <div className="title">
            
            <h2>{ title }</h2>
            
        </div>
    
        <div className="layout">

            <aside>

                <ul>

                    { PoliciesDatasets ().Routes.map ( ( policy, index ) => <li key={ index }>

                        <NavLink 
                        
                            to={ policy.URI } 
                        
                            className={ ( { isActive } ) => ( isActive ? 'active' : 'inactive' ) }>

                                { policy.name }

                        </NavLink>

                    </li> ) }

                </ul>

            </aside>

            <section>{ children }</section>

        </div>
    
    </div> );

}

/** Export component */
 
export default PoliciesLayout;